/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_No_Events_Clipboard_ErrorInputs */

const en_shortcut_keys_no_events_clipboard_error = /** @type {(inputs: Shortcut_Keys_No_Events_Clipboard_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No events found in clipboard`)
};

const fr_shortcut_keys_no_events_clipboard_error = /** @type {(inputs: Shortcut_Keys_No_Events_Clipboard_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun evenement trouve dans le presse-papiers`)
};

const de_shortcut_keys_no_events_clipboard_error = /** @type {(inputs: Shortcut_Keys_No_Events_Clipboard_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Ereignisse in der Zwischenablage gefunden`)
};

const it_shortcut_keys_no_events_clipboard_error = /** @type {(inputs: Shortcut_Keys_No_Events_Clipboard_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun evento trovato negli appunti`)
};

const ru_shortcut_keys_no_events_clipboard_error = /** @type {(inputs: Shortcut_Keys_No_Events_Clipboard_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В буфере обмена событий не найдено.`)
};

const es_shortcut_keys_no_events_clipboard_error = /** @type {(inputs: Shortcut_Keys_No_Events_Clipboard_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron eventos en el portapapeles`)
};

const zh_cn2_shortcut_keys_no_events_clipboard_error = /** @type {(inputs: Shortcut_Keys_No_Events_Clipboard_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`剪贴板中未找到任何事件`)
};

const ja_shortcut_keys_no_events_clipboard_error = /** @type {(inputs: Shortcut_Keys_No_Events_Clipboard_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリップボードにイベントが見つかりません`)
};

const hi_shortcut_keys_no_events_clipboard_error = /** @type {(inputs: Shortcut_Keys_No_Events_Clipboard_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्लिपबोर्ड में कोई इवेंट नहीं मिला`)
};

const pt_pt2_shortcut_keys_no_events_clipboard_error = /** @type {(inputs: Shortcut_Keys_No_Events_Clipboard_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum evento encontrado na área de transferência`)
};

/**
* | output |
* | --- |
* | "No events found in clipboard" |
*
* @param {Shortcut_Keys_No_Events_Clipboard_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_no_events_clipboard_error = /** @type {((inputs?: Shortcut_Keys_No_Events_Clipboard_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_No_Events_Clipboard_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_no_events_clipboard_error(inputs)
	if (locale === "de") return de_shortcut_keys_no_events_clipboard_error(inputs)
	if (locale === "it") return it_shortcut_keys_no_events_clipboard_error(inputs)
	if (locale === "ru") return ru_shortcut_keys_no_events_clipboard_error(inputs)
	if (locale === "es") return es_shortcut_keys_no_events_clipboard_error(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_no_events_clipboard_error(inputs)
	if (locale === "ja") return ja_shortcut_keys_no_events_clipboard_error(inputs)
	if (locale === "hi") return hi_shortcut_keys_no_events_clipboard_error(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_no_events_clipboard_error(inputs)
	return en_shortcut_keys_no_events_clipboard_error(inputs)
});